import React, { useState, useEffect } from 'react';

// Import images directly from the assets folder within src
import h1 from '../assets/1.jpg';
import h2 from '../assets/2.jpg';
import h3 from '../assets/3.jpg';
import h4 from '../assets/4.jpg';
import h5 from '../assets/5.jpg';
import h6 from '../assets/6.jpg';
import h7 from '../assets/2.jpg';
import h8 from '../assets/1.jpg';

const InstagramFeed = () => {
  // --- STATE DEFINITIONS ---
  // Define isMobile state: Must be inside the component
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Initialize isVisible to false, it will be set to true by an observer if needed
  // For this component, it looks like you're manually triggering it with a setTimeout,
  // but if it's meant for Intersection Observer, the logic would need to be added.
  // For now, let's make it controllable for the animatedButtonStyle.
  const [isVisible, setIsVisible] = useState(false);

  // State for the "ON THE GRAM" heading animation
  const [inView, setInView] = useState(false);

  // --- useEffect HOOKS ---
  useEffect(() => {
    // For "ON THE GRAM" heading animation
    const timer = setTimeout(() => {
      setInView(true);
    }, 500);

    // For isMobile state on resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    // For the animatedButtonStyle's entrance animation (if it's related to scroll/visibility)
    // If this section becomes visible, trigger isVisible
    // For simplicity, let's also trigger it after a delay, or you can integrate Intersection Observer here.
    const visibilityTimer = setTimeout(() => {
      setIsVisible(true);
    }, 1000); // Trigger after 1 second for the button animation

    return () => {
      clearTimeout(timer);
      clearTimeout(visibilityTimer); // Cleanup visibility timer
      window.removeEventListener('resize', handleResize); // Cleanup resize listener
    };
  }, []); // Empty dependency array means this runs once on mount

  // --- HELPER FUNCTION (must be defined AFTER state it depends on) ---
  const getAnimatedStyle = (baseStyle, delay) => ({
    ...baseStyle,
    // Only apply animation if isVisible is true
    transform: isVisible ? 'translateY(0)' : baseStyle.transform,
    opacity: isVisible ? 1 : baseStyle.opacity,
    transition: `transform 1s ease ${delay}s, opacity 1s ease ${delay}s`,
  });

  // --- STYLE OBJECTS (must be defined AFTER states they depend on) ---
  const buttonStyleBase = {
    // isMobile is now defined
    margin: isMobile ? '30px auto 0' : '30px 0 0 0',
    padding: isMobile ? '6px 20px' : '6px 20px',
    backgroundColor: '#D6A54F',
    color: '#fff',
    border: 'none',
    borderRadius: '25px',
    // isMobile is now defined
    fontSize: isMobile ? '15px' : '15px',
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    textDecoration: 'none',
    position: 'relative',
    overflow: 'hidden',
    zIndex: 1,
    transform: 'translateY(20px)', // Initial state for animation
    opacity: 0, // Initial state for animation
    // The '& > *' syntax is SCSS/Styled-components specific, not plain JS object for inline style.
    // If you need this, it belongs in the <style> tag or a CSS file.
    // For inline styles, you can only style the direct element.
    // '& > *': {
    //   position: 'relative',
    //   zIndex: 2,
    // },
    // Adding transition for general button style
    transition: 'background-color 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease',
  };

  // animatedButtonStyle needs getAnimatedStyle and buttonStyleBase to be defined first
  const animatedButtonStyle = getAnimatedStyle(buttonStyleBase, 0.8);


  // Standard button style for the "Follow Us" button
  


  const instagramPosts = [
    { id: 1, src: h1, alt: 'Hotel Interior 1' },
    { id: 2, src: h2, alt: 'Hotel Interior 2' },
    { id: 3, src: h3, alt: 'Hotel Interior 3' },
    { id: 4, src: h4, alt: 'Hotel Interior 4' },
    { id: 5, src: h5, alt: 'Hotel Interior 5' },
    { id: 6, src: h6, alt: 'Hotel Interior 6' },
    { id: 7, src: h7, alt: 'Hotel Interior 7' },
    { id: 8, src: h8, alt: 'Hotel Interior 8' },
  ];


  return (
    <div className="instagram-section">
      <div className="instagram-header">
        <h4
          style={{
            color: '#D4A762',
            fontWeight: '500',
            fontSize: '18px',
            marginBottom: '10px',
            letterSpacing: '1px',
            transform: inView ? 'translateY(0) translateX(0)' : 'translateY(30px)',
            opacity: inView ? 1 : 0,
            transition: inView
              ? 'transform 1s ease-out 0.3s, opacity 1s ease-out 0.3s'
              : 'none',
          }}
        >
          ON THE GRAM
        </h4>

        <br/>
        <h2 className="instagram-title">Discover the Taste of Elegance | Experience Dining Like Never Before at The Porch</h2>
      </div>

      <div className="instagram-grid-container">
        <div className="instagram-posts-grid">
          {instagramPosts.map(post => (
            <div key={post.id} className="instagram-post-card">
              <img src={post.src} alt={post.alt} loading="lazy" />
            </div>
          ))}
        </div>
      </div>

      {/* Buttons container to allow them to sit side-by-side or stack */}
      <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '20px', marginBottom: '20px' }}>
       

        <a href="https://www.instagram.com/_the.porch/" style={{ textDecoration: 'none' }}>
          <button
            style={animatedButtonStyle}
            className="hero-button" // Keep the class if you have external CSS for it
          >
            <i className="fab fa-instagram" style={{ marginRight: '10px', fontSize: '1.55em' }}></i> {/* Adjusted font size for 5% increase based on 1.5em for fa-xl */}
            Follow Us    </button>
        </a>
      </div>


      {/* Embedded CSS for styling */}
      <style dangerouslySetInnerHTML={{ __html: `
        .instagram-section {
          text-align: center;
          padding: 60px 20px;
          background-color: #f8f8f8;
        }

        .instagram-header {
          margin-bottom: 40px;
        }

        .instagram-title {
          
          font-family: 'Playfair Display', serif; /* Added serif fallback */
          font-size: 1.4em;
          color: #333;
          margin: 0;
          font-weight: 500;
          line-height: 1.3;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }

        .instagram-grid-container {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 40px;
        }

        .instagram-posts-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr); /* 4 columns on large screens */
          grid-template-rows: repeat(2, 1fr);   /* 2 rows */
          gap: 20px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .instagram-post-card {
          position: relative;
          overflow: hidden;
          cursor: pointer;
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }

        .instagram-post-card img {
          width: 100%;
          height: 250px;
          object-fit: cover;
          display: block;
          transition: transform 0.3s ease-in-out;
        }

        .instagram-post-card:hover img {
          transform: scale(1.05);
        }

        /* Mirror Effect for Instagram Posts */
        .instagram-post-card::after {
          content: '';
          position: absolute;
          width: 200%; /* Wider to cover the diagonal sweep */
          height: 100%;
          background: rgba(255, 255, 255, 0.2); /* Semi-transparent white */
          transform: translateX(-100%) rotate(45deg); /* Start off-screen to the left, rotated */
          transition: transform 0.5s ease-out; /* Smooth transition for the effect */
          z-index: 1; /* Ensure it's above the image */
          top: 0;
          left: 0;
        }

        .instagram-post-card:hover::after {
          transform: translateX(100%) rotate(45deg); /* Sweep across to the right */
        }

        /* Styles for the Follow Us button */
        .instagram-follow-button {
            /* If you want to add common styles to both buttons via CSS, you can add them here. */
        }

        .instagram-follow-button:hover {
            background-color: #c09444; /* Slightly darker gold on hover */
            box-shadow: 0 6px 12px rgba(0,0,0,0.2); /* More pronounced shadow on hover */
            transform: translateY(-2px); /* Optional: slight lift effect */
        }

      

        .hero-button:hover {
            background-color: #c09444; /* Slightly darker gold on hover */
            box-shadow: 0 6px 12px rgba(0,0,0,0.2); /* More pronounced shadow on hover */
            transform: translateY(-2px); /* Optional: slight lift effect */
        }


        /* Responsive adjustments */
        @media (max-width: 1200px) {
          .instagram-posts-grid {
            grid-template-columns: repeat(3, 1fr);
            grid-template-rows: repeat(auto-fill, 1fr);
            max-width: 900px;
          }
        }

        @media (max-width: 992px) {
          .instagram-posts-grid {
            grid-template-columns: repeat(2, 1fr);
            max-width: 600px;
          }
        }

        @media (max-width: 768px) {
          .instagram-title {
            font-size: 1.6em;
          }
          .instagram-posts-grid {
            grid-template-columns: repeat(2, 1fr);
            max-width: 600px;
            gap: 15px;
          }
        }

        @media (max-width: 480px) {
          .instagram-section {
            padding: 30px 15px;
          }
          .instagram-header {
            margin-bottom: 25px;
          }
          .instagram-title {
            font-size: 1.4em;
          }
          .instagram-posts-grid {
            grid-template-columns: repeat(2, 1fr);
            max-width: 300px;
            gap: 10px;
          }
          .instagram-post-card img {
            height: 200px;
          }
          
        }
      ` }} />
    </div>
  );
};

export default InstagramFeed;